import * as B from '@blueprintjs/core';
import React from 'react';

import {DEFAULT_WIDGET_ID} from 'app/components/Dashboard/DefaultConfig';
import cs from 'app/components/Dashboard/MultiFeatureAnalysisWidget/MultiFeatureAnalysis.module.scss';
import {WidgetConfig} from 'app/components/Dashboard/types';

export const MFAWidgetControls: React.FC<{
  isExpanded: boolean;
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  onResize?: (direction: 'minimize' | 'maximize') => void;
  onExportPng: () => void;
  onExportCsv: () => void;
  onShare: () => void;
  widgetConfig: WidgetConfig;
  chartHidden?: boolean;
}> = ({
  isExpanded,
  setIsExpanded,
  onResize,
  onExportPng,
  onExportCsv,
  onShare,
  widgetConfig,
  chartHidden,
}) => {
  const canShare = 'statAggregation' in widgetConfig && widgetConfig.id !== DEFAULT_WIDGET_ID;
  return (
    <>
      <div className={cs.widgetControlsContainer}>
        <B.Tooltip content={isExpanded ? 'Hide details' : 'Show details'}>
          <B.AnchorButton
            icon={isExpanded ? 'minimize' : 'maximize'}
            minimal
            small
            onClick={() => {
              setIsExpanded((prev) => !prev);
              onResize?.(isExpanded ? 'minimize' : 'maximize');
            }}
          />
        </B.Tooltip>
        <B.Popover
          content={
            <B.Menu>
              {!chartHidden && (
                <B.MenuItem icon="download" text="Download chart as PNG" onClick={onExportPng} />
              )}
              <B.MenuItem icon="th" text="Download table as CSV" onClick={onExportCsv} />
              {canShare && <B.MenuItem icon="share" text="Share" onClick={onShare} />}
            </B.Menu>
          }
          placement="bottom-end"
          minimal
        >
          <B.Button icon="more" minimal small />
        </B.Popover>
      </div>
    </>
  );
};
